export const AppsGatewaySwitcherTags = {
    AppsGatewaySwitcher: 'apps-gateway-switcher',
    AppsGatewaySwitcherItem: 'apps-gateway-switcher-item'
};

